console.log("MONO REPORT V2");

document.addEventListener("DOMContentLoaded", () => {

const params = new URLSearchParams(window.location.search);

const report = {

stage: Number(params.get("stage") || 1),

gut: params.get("gut") || "baseline",

stress: params.get("stress") || "baseline",

hormones: params.get("hormones") || "baseline"

};


/* =====================================================
   PDP LINKS
===================================================== */

const PDP = {

1:"https://monoskin.health/products/stage-1-mild-acne",

2:"https://monoskin.health/products/stage-2-mixed-acne",

3:"https://monoskin.health/products/stage-3-deep-cystic-acne",

4:"https://monoskin.health/products/stage-4-post-acne"

};


/* =====================================================
   STAGE DATA
===================================================== */

const STAGES={

1:{

title:"STAGE 1",

subtitle:"Surface Clog & Congestion Profile",

confidence:94,

explanation:
"Your skin is experiencing clogged pores caused by excess oil and trapped dead skin cells. This stage responds best to early correction before inflammation develops."

},

2:{

title:"STAGE 2",

subtitle:"Active Recurrent Breakout Profile",

confidence:92,

explanation:
"Recurring inflammatory acne indicates bacterial activity together with internal triggers such as diet, hormones or stress. Early intervention helps prevent long-term skin damage."

},

3:{

title:"STAGE 3",

subtitle:"Deep Seated Tissue Profile",

confidence:96,

explanation:
"Your assessment indicates deep inflammatory acne. The priority is calming inflammation internally while protecting your skin barrier during recovery."

},

4:{

title:"STAGE 4",

subtitle:"Post Acne Marks & Recovery",

confidence:93,

explanation:
"Active acne has reduced but pigmentation and texture remain. The focus shifts to collagen support, pigmentation control and skin renewal."

}

};



/* =====================================================
   TIMELINES
===================================================== */

const TIMELINES={

1:[

{

day:"Days 1–30",

title:"Reset",

body:"Reduce congestion and normalize oil flow."

},

{

day:"Days 31–60",

title:"Repair",

body:"Refine pores and improve skin turnover."

},

{

day:"Days 61–90",

title:"Renew",

body:"Strengthen barrier and maintain clear skin."

}

],


2:[

{

day:"Days 1–30",

title:"Flush",

body:"Reduce active inflammation."

},

{

day:"Days 31–60",

title:"Repair",

body:"Balance internal triggers."

},

{

day:"Days 61–90",

title:"Renew",

body:"Fade marks and strengthen skin."

}

],


3:[

{

day:"Days 1–30",

title:"Calm",

body:"Reduce deep tissue inflammation."

},

{

day:"Days 31–60",

title:"Heal",

body:"Repair damaged tissue."

},

{

day:"Days 61–90",

title:"Recover",

body:"Prevent future cyst formation."

}

],


4:[

{

day:"Days 1–30",

title:"Brighten",

body:"Reduce pigmentation."

},

{

day:"Days 31–60",

title:"Repair",

body:"Improve skin texture."

},

{

day:"Days 61–90",

title:"Glow",

body:"Reveal healthy skin."

}

]

};



/* =====================================================
   EXPECTED RESULTS
===================================================== */

const RESULTS={

1:[

"Reduced congestion",

"Less oil build-up",

"Smaller pores",

"Healthier skin barrier"

],

2:[

"Reduced redness",

"Fewer breakouts",

"Balanced oil production",

"Calmer skin"

],

3:[

"Reduced cysts",

"Reduced inflammation",

"Better healing",

"Improved texture"

],

4:[

"Reduced pigmentation",

"Brighter complexion",

"Smoother skin",

"Healthy glow"

]

};



/* =====================================================
   TESTIMONIALS
===================================================== */

const TESTIMONIALS={

1:{

name:"Priya",

text:"Within two months my pores became visibly cleaner and my skin felt smoother."

},

2:{

name:"Anjali",

text:"The redness reduced dramatically and new breakouts almost stopped."

},

3:{

name:"Riya",

text:"This was the first routine that actually calmed my painful cystic acne."

},

4:{

name:"Sneha",

text:"My acne marks faded much faster than I expected."

}

};



const current=STAGES[report.stage];

/* =====================================================
   HERO
===================================================== */

document.getElementById("stage-badge").innerHTML = `

<div class="stage-title">

${current.title}

</div>

<div class="stage-subtitle">

${current.subtitle}

</div>

`;

document.getElementById("confidence-score").innerHTML =
current.confidence;

// document.getElementById("stage-explanation").innerHTML =
// current.explanation;


/* =====================================================
   STATUS PILLS
===================================================== */

function renderStatus(id,status){

const el=document.getElementById(id);

if(status==="high"){

el.innerHTML="🔴 Elevated";

el.className="alert-red";

}

else{

el.innerHTML="🟢 Balanced";

el.className="alert-green";

}

}

renderStatus("gut-status",report.gut);

renderStatus("stress-status",report.stress);

renderStatus("hormone-status",report.hormones);

animateBar("gut-bar","gut-percent",report.gut);

animateBar("stress-bar","stress-percent",report.stress);

animateBar("hormone-bar","hormone-percent",report.hormones);

/* =====================================================
   ROOT CAUSE BARS
===================================================== */

function animateBar(bar, label, status) {

    const percent = status === "high" ? 88 : 28;

    const el = document.getElementById(bar);
    const txt = document.getElementById(label);

    console.log("BAR:", bar, el);
    console.log("LABEL:", label, txt);

    if (!el || !txt) {
        console.error("Element not found:", bar, label);
        return;
    }

    txt.textContent = percent + "%";

    el.style.width = percent + "%";
    el.style.height = "100%";
    el.style.background = "#22C55E";
}



/* =====================================================
   TIMELINE
===================================================== */

// let timelineHTML="";

// TIMELINES[report.stage].forEach((item,index)=>{

// timelineHTML+=`

// <div class="timeline-step">

// <div class="timeline-icon">

// ${index+1}

// </div>

// <div class="timeline-content">

// <h4>

// ${item.day}

// •

// ${item.title}

// </h4>

// <p>

// ${item.body}

// </p>

// </div>

// </div>

// `;

// });

// document.getElementById("timeline-content")
// .innerHTML=timelineHTML;



/* =====================================================
   EXPECTED RESULTS
===================================================== */

let resultHTML="";

RESULTS[report.stage].forEach(item=>{

resultHTML+=`

<li>

✅ ${item}

</li>

`;

});

document.getElementById("expected-results")
.innerHTML=resultHTML;



/* =====================================================
   CTA
===================================================== */

const planBtn = document.getElementById("planBtn");
const detailsBtn = document.getElementById("detailsBtn");
const stickyBtn = document.getElementById("stickyBuyBtn");

if (planBtn) {
    planBtn.href = PDP[report.stage];
}

if (detailsBtn) {
    detailsBtn.href = PDP[report.stage];
}

if (detailsBtn && stickyBtn) {
    stickyBtn.href = detailsBtn.href;
}

const VARIANTS = {
    1: 45682478415929,
    2: 45683460603961,
    3: 45683565854777,
    4: 45687458496569
};

async function openCartDrawer() {

    document.dispatchEvent(
        new CustomEvent("cart:refresh", {
            detail: {
                open: true
            }
        })
    );

}

if (stickyBtn) {

    stickyBtn.removeAttribute("href");

    stickyBtn.addEventListener("click", async function (e) {

        e.preventDefault();

      const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
        "Content-Type": "application/json"
    },
    body: JSON.stringify({
        id: VARIANTS[report.stage],
        quantity: 1
    })
});
if (response.ok) {

    if (window.innerWidth <= 768) {

        // Mobile
        window.location.href = "/cart";

    } else {

        // Desktop
        setTimeout(() => {
            document.dispatchEvent(
                new CustomEvent("cart:refresh", {
                    detail: {
                        open: true
                    }
                })
            );
        }, 300);

    }

}

    });

}
/* =====================================================
   CONFIDENCE COUNT ANIMATION
===================================================== */

let count=0;

const final=current.confidence;

const timer=setInterval(()=>{

count++;

document.getElementById("confidence-score")
.innerHTML=count;

if(count>=final){

clearInterval(timer);

}

},15);

/* =====================================================
   TESTIMONIALS
===================================================== */


/* =====================================================
   STAGE BANNERS
===================================================== */

const STAGE_BANNERS = {

    1: {

        image: "https://cdn.shopify.com/s/files/1/0731/7536/7737/files/Month_1_First_month.svg?v=1785853461",

        // button1: {
        //     text: "Try 30-Day Trial Plan"
        //     link: "https://monoskin.health/products/stage-1-1st-month-detox-acne-control"
        // },

        // button2: {
        //     text: "Buy 90-Day Plan",
        //     link: "https://monoskin.health/products/stage-1-clog-congestion-90-day-skin-clarifying-plan"
        // }

    },

    2: {

        image: "https://cdn.shopify.com/s/files/1/0731/7536/7737/files/Month_2_First_month.svg?v=1785853461",

        // button1: {
        //     text: "Try 30-Day Trial Plan",
        //     link: "https://monoskin.health/products/stage-1-1st-month-detox-acne-control"
        // },

        // button2: {
        //     text: "Buy 90-Day Plan",
        //     link: "https://monoskin.health/products/stage-1-clog-congestion-90-day-skin-clarifying-plan"
        // }

    },

    3: {

        image: "https://cdn.shopify.com/s/files/1/0731/7536/7737/files/Month_3_First_month.svg?v=1785853460",

        // button1: {
        //     text: "Try 30-Day Trial Plan",
        //     link: "https://monoskin.health/products/stage-3-month-1-calm-control"
        // },

        // button2: {
        //     text: "Buy 90-Day Plan",
        //     link: "https://monoskin.health/products/stage-3-deep-inflammation-90-day-acne-recovery-plan"
        // }

    },
    

    4: {

        image: "https://cdn.shopify.com/s/files/1/0731/7536/7737/files/Month_4_First_month.svg?v=1785853460",

        // button1: {
        //     text: "Try 30-Day Trial Plan",
        //     link: "https://monoskin.health/products/stage-4-month-1-brighten-fade"
        // },

        // button2: {
        //     text: "Buy 90-Day Plan",
        //     link: "https://monoskin.health/products/stage-4-post-acne-marks-scars-90-day-acne-recovery-plan"
        // }

    }

};

/* =====================================================
   BEFORE / AFTER
===================================================== */
/* =====================================================
   RENDER STAGE BANNER
===================================================== */

const banner = STAGE_BANNERS[report.stage];

const bannerSection = document.getElementById("stage-banner-section");

if (bannerSection && banner) {

    bannerSection.innerHTML = `
        <img
            src="${banner.image}"
            alt="Stage Banner"
            class="stage-banner"
        >

        <div class="stage-button-group">
            <a
                id="stageAddToCart"
                href="#"
                class="cta-button"
            >
                Add to cart
            </a>
        </div>
    `;

    const stageAddToCart = document.getElementById("stageAddToCart");

    if (stageAddToCart) {

   stageAddToCart.addEventListener("click", async function (e) {

    e.preventDefault();

    const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            id: VARIANTS[report.stage],
            quantity: 1
        })
    });

    if (response.ok) {

    if (window.innerWidth <= 768) {

        // Mobile
        window.location.href = "/cart";

    } else {

        // Desktop
        setTimeout(() => {
            document.dispatchEvent(
                new CustomEvent("cart:refresh", {
                    detail: {
                        open: true
                    }
                })
            );
        }, 300);

    }

}

});
    }

}

const STAGE_IMAGES = {

    1: "https://cdn.shopify.com/s/files/1/0731/7536/7737/files/1_4.svg?v=1783543001",

    2: "https://cdn.shopify.com/s/files/1/0731/7536/7737/files/3_3.svg?v=1783543002",

    3: "https://cdn.shopify.com/s/files/1/0731/7536/7737/files/2_5.svg?v=1783543001g",

    4: "https://cdn.shopify.com/s/files/1/0731/7536/7737/files/1_4.svg?v=1783543001"

};

const slider = document.querySelector(".before-after-slider");

if (slider) {

    slider.innerHTML = `
        <div class="result-card">
            <img src="${STAGE_IMAGES[report.stage]}" alt="Customer Result">
        </div>
    `;

}



/* =====================================================
   FADE ANIMATION
===================================================== */

const observer = new IntersectionObserver(entries=>{

entries.forEach(entry=>{

if(entry.isIntersecting){

entry.target.classList.add("show");

}

});

},{
threshold:.15
});


document.querySelectorAll(

".hero-card,.section-card,.cta-card"

).forEach(card=>{

card.classList.add("fade-card");

observer.observe(card);

});


const progressCircle=document.querySelector(".progress-circle");

const percent=document.getElementById("resultsPercent");

let value=1;

const target=97;

const animation=setInterval(()=>{

value++;

percent.innerHTML=value+"%";

const degree=(value/100)*360;

progressCircle.style.background=
`conic-gradient(#7673ff ${degree}deg,#ECECEC ${degree}deg)`;

if(value>=target){

clearInterval(animation);

}

},20);

/* =====================================================
   CTA PULSE
===================================================== */

setInterval(() => {

    document.querySelectorAll(".cta-button").forEach(btn => {

        btn.classList.add("pulse");

        setTimeout(() => {
            btn.classList.remove("pulse");
        }, 1200);

    });

}, 5000);



/* =====================================================
   REPORT READY
===================================================== */

console.log("Mono Diagnosis Report Ready");

});